import React, { useState, useEffect } from 'react';
import lifePlan from "../SmcLife/Images/lifeplan.png";
import TaxBenepic from "../SmcLife/Images/Group2265.svg";
import '../SmcLife/IndexLife.css';
import axios from 'axios';
const LifeMoreDetail = ({ history }) => {

    const [AnnualIncome, setAnnualIncome] = useState("");
    const [CoverTillAge, setCoverTillAge] = useState("");
    const [Detail, setDetail] = useState("N");
    const [BtnVal, setBtnVal] = useState("Get Quotes");
    const [PrvData, setPrvData] = useState(null);

    useEffect(() => {
        setPrvData(history?.location?.state?.Req);
    }, [])

    const submitForm = () => {
        let goto = true;
        //debugger;
        if (goto) {
            const header = {
                "ApiKey": '5520aaa5-0951-4537-b215-b35f6e65e94f',
                "PassKey": "9250ced2656be564"
            }

            setBtnVal("Wait....")

            let req = {
                "ClientID": "52",
                "UserID": 0,
                "MobileNo": PrvData.MobileNo,
                "InsurerAge": 18,
                "Gender": PrvData.Gender,
                "SmokeStatus": Detail,
                "AnnualIncome": AnnualIncome,
                "SumInsured": 10000000,
                "PolicyTerm": 30,
                "PolicyType": "Termlife",
                "BusinessID": null,
                "DOB": PrvData.DOB,
                "Email": PrvData.Email,
                "CoverTillAge": CoverTillAge
            }
            //console.log('req----:,', req)

            //axios.post("https://preprod.smcinsurance.com/lifeapi/api/Enquiry/AddEnquiry", req, { headers: header }).then(res => {
            axios.post("https://termlifeapi.smcinsurance.com:450/api/Enquiry/AddEnquiry", req, { headers: header }).then(res => {
                //debugger;
                req.EnquiryNo = res.data.Data.EnquiryNo;
                history.push({
                    pathname: '/SmcLifeQuote',
                    state: { Req: req }
                });
            }).catch(err => console.log(err));
        }
    }

    return (
        <>
            <div className="MoreDetailMainpage">
                <div className="space">
                    <div className="container">
                        <div className="Life_Index_For_Box">
                            <div className="row">
                                <div className="col-lg-3 offset-lg-1 mt-5">
                                    <h4 className="Index-Plan">Term Life Plans at <br /><span className="textcolor">Lowest Rates</span></h4>
                                    <p className="Index-Plan-Cont">We suggest best plans as per <br />your life stage</p>
                                    <div className="Added_PicTaxBenefitBox">

                                        <img src={lifePlan} className="imgtop m-auto w-auto" alt="Life Plan Image" />

                                        <div className="TaxBenefits">
                                            <img src={TaxBenepic} alt="Get tax" />
                                            <div className="GetLifeCNT">
                                                <p>Get tax benefits up to</p>
                                                <h2>₹ 1.5 Lakh</h2>
                                                <p>under section 80C</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 landing-area offset-lg-1 mt-5">
                                    <div className="IndexLife-cards">
                                        <form>
                                            <p><b>Few More Details</b></p>

                                            <p className="mb-1"><b>Do you smoke or chew tobacco?</b></p>
                                            <label>
                                                <input type="radio" value="N" name="Detail" checked={Detail === "N"} onChange={(e) => setDetail(e.target.value)} />
                                                No
                                            </label>
                                            <label>
                                                <input type="radio" value="Y" name="Detail" checked={Detail === "Y"} onChange={(e) => setDetail(e.target.value)} />
                                                Yes
                                            </label>
                                            <p className="lifecheck">Choose 'Yes' if you have smoked or chewed tobacco in last 1 year</p>

                                            <select name="dropdown" id="Income" className="IndexFormBox" value={AnnualIncome} onChange={(e) => setAnnualIncome(e.target.value)}>
                                                <option value="Approx Annual Income">Approx. Annual Income</option>
                                                <option value="18">18 Lakhs</option>
                                                <option value="19">19 Lakhs</option>
                                                <option value="20">20 Lakhs</option>
                                                <option value="21">21 Lakhs</option>
                                                <option value="22">22 Lakhs</option>
                                                <option value="23">23 Lakhs</option>
                                                <option value="24">24 Lakhs</option>
                                                <option value="25">25 Lakhs</option>
                                                <option value="26">26 Lakhs</option>
                                                <option value="27">27 Lakhs</option>
                                            </select>

                                            <select name="dropdown" id="Age" className="IndexFormBox mt-4" value={CoverTillAge} onChange={(e) => setCoverTillAge(e.target.value)}>
                                                <option value="Cover Till Age">Cover Till Age</option>
                                                <option value="18 Year">18 Year</option>
                                                <option value="19 Year">19 Year</option>
                                                <option value="20 Year">20 Year</option>
                                                <option value="21 Year">21 Year</option>
                                                <option value="22 Year">22 Year</option>
                                                <option value="23 Year">23 Year</option>
                                                <option value="24 Year">24 Year</option>
                                                <option value="25 Year">25 Year</option>
                                                <option value="26 Year">26 Year</option>
                                                <option value="27 Year">27 Year</option>
                                                <option value="28 Year">28 Year</option>
                                                <option value="29 Year">29 Year</option>
                                                <option value="30 Year">30 Year</option>
                                            </select>

                                            <button onClick={submitForm} type="button" className="FormGetTouch d-block w-100 mb-1" disabled={!AnnualIncome || !CoverTillAge}>{BtnVal}</button>
                                            <p><small>By clicking I agree to all</small> <span className="textcolor">T&C</span></p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
export default LifeMoreDetail;